import ReactDOM from "react-dom"
import React from "react"
import PlacesAutocomplete from "./Components/PlacesAutocomplete"

const rootEl = document.getElementById("react-places-autocomplete");

rootEl && ReactDOM.render(<PlacesAutocomplete />, rootEl)